var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMLogo(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.2923 0C14.108 0 14.7692 0.671573 14.7692 1.5V10.5C14.7692 11.3284 14.108 12 13.2923 12C12.4766 12 11.8154 11.3284 11.8154 10.5V4.5C11.8154 3.67157 11.1541 3 10.3385 3C9.52278 3 8.86154 3.67157 8.86154 4.5V10.5C8.86154 11.3284 8.2003 12 7.38462 12C6.56893 12 5.90769 11.3284 5.90769 10.5V4.5C5.90769 3.67157 5.24645 3 4.43077 3H1.47692C0.661241 3 0 2.32843 0 1.5C0 0.671573 0.661241 0 1.47692 0H13.2923Z",
    fill: "#CCD5D3",
    style: (_ref2 = {
      fill: "#CCD5D3"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.75C0 5.92157 0.661241 5.25 1.47692 5.25C2.29261 5.25 2.95385 5.92157 2.95385 6.75V10.5C2.95385 11.3284 2.29261 12 1.47692 12C0.661241 12 0 11.3284 0 10.5V6.75Z",
    fill: "#CCD5D3",
    style: (_ref3 = {
      fill: "#CCD5D3"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLogo);
export default __webpack_public_path__ + "static/media/mLogo.34c45eea.svg";
export { ForwardRef as ReactComponent };